(function () {
  var LOG = '[join-email]';
  var SELECTOR = '[data-join-email-newsletter]';

  function mountForm(root, attempt) {
    if (!window.hbspt || !window.hbspt.forms || !window.hbspt.forms.create) {
      if (typeof attempt === 'number' && attempt % 20 === 1) {
        console.log(LOG, 'waiting for hbspt', { attempt: attempt });
      }
      return false;
    }
    var portalId = root.getAttribute('data-portal-id');
    var formId = root.getAttribute('data-form-id');
    var region = root.getAttribute('data-region') || 'na1';
    if (!portalId || !formId || !root.id) {
      console.warn(LOG, 'missing portal, form id, or root id');
      return false;
    }
    window.hbspt.forms.create({
      portalId: portalId,
      formId: formId,
      region: region,
      target: '#' + root.id,
    });
    return true;
  }

  function init() {
    var root = document.querySelector(SELECTOR);
    if (!root) {
      return;
    }
    if (mountForm(root, 0)) {
      return;
    }
    var n = 0;
    var t = window.setInterval(function () {
      n += 1;
      if (mountForm(root, n)) {
        window.clearInterval(t);
      } else if (n > 80) {
        window.clearInterval(t);
        console.warn(LOG, 'hbspt timeout');
      }
    }, 50);
  }

  init();
})();
